import createDefaultWait from "../../../createDefaultWait"
import type { Engine } from "../../engine/Engine.type"
import { PlayerTurnStatus } from "../../player/PlayerTurnStatus"
import { createStartTurnAction } from "../../state/flux/action/Game/StartTurnAction"
import dispatchClient from "../../state/flux/dispatchClient"
import type { Bot } from "../Bot.type"

export default async function botStartTurn(
  engine: Engine,
  bot: Bot
) {
  console.log('%c[botStartTurn]', 'color: grey; font-weight: lighter; font-size: 10px;')
  if (bot.player.turn_status === PlayerTurnStatus.Pending) {
    await dispatchClient(engine, createStartTurnAction(bot.player.id))
    await createDefaultWait(bot.stepDelay)
  }
}